export const createActivatedSchedulerFilters = (set, get) => ({
    activatedSchedulerFilters: {  
        searchName: "",
        userType: "",
    },
    setActivatedSchedulerFilters: (newFilter) =>
        set((state) => ({
            activatedSchedulerFilters: {
                ...state.activatedSchedulerFilters,
                ...newFilter,
            },
        })),
});



// WEBPACK FOOTER //
// ./src/store/slices/ActivatedSchedulerSlice/activatedSchedulerSlice.js